import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "astreinte-container",
  role: "alertdialog",
  "aria-labelledby": "astreinte-title"
}
const _hoisted_2 = { class: "titre-container" }
const _hoisted_3 = { id: "astreinte-title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onCancel: _ctx.cancel }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('modale.astreinte.titre')), 1),
          _createVNode(_component_ReglePastille, { cle: "demandeIntervention.astreinte" })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.societesAstreinte, (societeAstreinte) => {
          return (_openBlock(), _createElementBlock("div", {
            key: societeAstreinte.societe
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(societeAstreinte.societe), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(societeAstreinte.telephone), 1)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('modale.astreinte.horaires')), 1),
        _createElementVNode("button", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          "aria-label": _ctx.$t('aria.fermer.modale')
        }, [
          _createElementVNode("img", {
            class: "close-icon",
            src: _ctx.closeIcon,
            alt: "",
            "aria-hidden": "true"
          }, null, 8, _hoisted_8)
        ], 8, _hoisted_7)
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}